import React from "react";
import Certificate1 from "../../assets/images/certificates/Halal.jpg";
import Certificate2 from "../../assets/images/certificates/FSSC 22000.png";
import Certificate3 from "../../assets/images/certificates/FSSAI.svg";
import Certificate4 from "../../assets/images/certificates/GMP Good Manufacturing Practice certified logo vector-07.jpg";
import Certificate5 from "../../assets/images/certificates/indian-organic.jpg";
import Certificate6 from "../../assets/images/certificates/USDA organic logo- badge vector-03.jpg";
import Certificate7 from "../../assets/images/certificates/iso_logo_01.jpg";
import { Row, Col } from "react-bootstrap";
import ImageContainer from "../../components/ImageContainer/ImageContainer";

export default function BrandsCerification() {
  const services = [
    // {
    //   title: "Community",
    //   image: Community,
    //   href: "/Community",
    // },
    
    
    {
      title: "FSSAI",
      image: Certificate3,
     
    },
    {
        title: "Indian Organic",
        image: Certificate5,
       
      },
      {
        title: "ISO ",
        image: Certificate7,
       
      },{
        title: "USDA ",
        image: Certificate6,
       
      },
      
      {
        title: "Food Safety System Certfication 22000",
        image: Certificate2,
        // customPropValue: "processing",
  
      },
      {
        title: "Good Manufacturing Practice",
        image: Certificate4,
       
      },
      {
        title: "Halal Certification",
        image: Certificate1,
        
      },
  ];

  return (
    <div className="container for-farmer-section2 subSectionWrapper px-0">
      <Row className="justify-content-between">
        {services.map((e) => (
          <Col md={3} key={e.title} className="mb-4">
             <ImageContainer title={e.title} src={e.image}/>
          </Col>
        ))}
      </Row>
    </div>
  );
}
